var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.441345 5.84277C0.441345 3.13755 1.83594 1.04348 3.97087 0.297518C7.02691 -0.763 10.3197 1.08841 10.8706 4.62947C11.1418 6.36404 10.7114 7.92786 9.64392 9.29395C8.49037 10.7679 7.32821 12.2328 6.16605 13.7068C5.85614 14.0977 5.52902 14.0977 5.21911 13.7068C4.01391 12.1744 2.79579 10.6511 1.6035 9.10521C0.815819 8.07615 0.454258 6.87183 0.441345 5.84277ZM5.69689 3.23641C4.55194 3.23641 3.63083 4.20256 3.63083 5.39789C3.63083 6.57974 4.56055 7.5414 5.69689 7.5414C6.82892 7.5414 7.75864 6.57075 7.75434 5.38891C7.75434 4.19807 6.82892 3.23192 5.69689 3.23641Z",
    fill: "#EAEAEA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.93e51134dfb396f4681d74a298cb2c39.svg";
export { ForwardRef as ReactComponent };